import { createAction, props } from '@ngrx/store';
import { Page } from '../../../domain/page';

const feature = '[Page selector]';

export const fetchPages = createAction(`${feature} Fetch pages`, props<{ term: string; excludeDrafts?: boolean }>());
export const fetchPagesSuccess = createAction(`${feature} Fetch pages success`, props<{ pages: Page[] }>());
export const fetchPagesFail = createAction(`${feature} Fetch pages fail`, props<{ errorMessage: string }>());
